import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { CheckoutState } from '@spartacus/checkout/base/root';
import { StateUtils } from '@spartacus/core';
import { CHECKOUT_DETAILS, CheckoutStepsState } from '../custom-checkout-state';
import * as fromCardTypes from './card-types.reducer';
import * as fromCheckout from './checkout.reducer';
import * as fromPaymentTypes from './custom-payment-types.reducer';
import * as fromOrderTypes from './order-types.reducer';

export function getReducers(): ActionReducerMap<CheckoutState> {
  return {
    steps: StateUtils.loaderReducer<CheckoutStepsState>(
      CHECKOUT_DETAILS,
      fromCheckout.reducer
    ),
    cardTypes: fromCardTypes.reducer,
    // CHANGE
    //addressVerification: fromAddressVerification.reducer,
    paymentTypes: fromPaymentTypes.reducer,
    orderType: fromOrderTypes.reducer,
  };
}

export const reducerToken: InjectionToken<
  ActionReducerMap<CheckoutState>
> = new InjectionToken<ActionReducerMap<CheckoutState>>('CheckoutReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
